document.addEventListener('teeinblue-event-after-cart-added', function() {
  const cartComponent = document.querySelector('cart-items-component');
  const cartDrawerComponent = document.querySelector('cart-drawer-component');

  if (!cartComponent || !window.sectionRenderer || !cartDrawerComponent) return;

  const sectionId = cartComponent.dataset.sectionId;
  window.sectionRenderer.renderSection(sectionId, { cache: false });

  setTimeout(function(){
    cartDrawerComponent.open();
  }, 1000)
});